<app-header #folderHeaderView [inFolderView]="true"></app-header>
<router-outlet></router-outlet>
